/**
 * Root layout: ThemeModeProvider (which owns the MUI ThemeProvider) + CssBaseline +
 * AuthProvider + Outlet. The auth provider sits above every route — the public `/auth/**`
 * routes need it just as much as the gated ones, since they are what establish the session.
 * U3 mounts the AuthGate-wrapped app shell as a child of this.
 *
 * The theme is built by `ThemeModeProvider` rather than here, because the light/dark choice
 * is state (a stored preference resolved against `prefers-color-scheme`) rather than a
 * constant — SASBND-0008 U2.
 */
import { CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import { ThemeModeProvider } from '@/theme/ThemeModeProvider';

export function RootLayout() {
  return (
    <ThemeModeProvider>
      {/*
        `enableColorScheme` emits `color-scheme: <mode>`, which is what tells the browser to
        paint its OWN surfaces — scrollbars, native form-control internals, the pre-paint
        canvas — to match. Without it a dark palette ships with a light scrollbar track and a
        white flash on load. MUI defaults it to `false`, and none of it is authored CSS, so no
        test can catch its absence.
      */}
      <CssBaseline enableColorScheme />
      <AuthProvider>
        <Outlet />
      </AuthProvider>
    </ThemeModeProvider>
  );
}
